import { AbstractControl, ValidationErrors } from '@angular/forms';
import { parsePhoneNumber, isValidPhoneNumber, PhoneNumber, CountryCode, NumberFormat } from 'libphonenumber-js';

export class PhoneNumberHelper {
  // Parse a phone number and return a PhoneNumber object. Defaults to US if no country code is found.
  static parse(phone: string, country?: CountryCode): PhoneNumber | undefined {
    if (!phone) {
      return undefined;
    }

    const countryCode = country || 'US';

    return parsePhoneNumber(phone, countryCode);
  }

  // Parses and formats a phone number in the specified format. Defaults to E.164 format.
  // Defaults to US if no country code is found.
  static formatPhone(phone: string, country?: CountryCode, numberFormat: NumberFormat = 'E.164'): string | undefined {
    if (!phone) {
      return undefined;
    }

    const parsedNumber = this.parse(phone, country);

    if (!parsedNumber) {
      return undefined;
    }

    return parsedNumber.format(numberFormat);
  }

  // Determine if a phone number is valid based on E.164 format.
  static isValid(phone: string, numberFormat: NumberFormat = 'E.164'): boolean {
    try {
      const formattedNumber = this.formatPhone(phone, undefined, numberFormat);

      if (!formattedNumber) {
        return false;
      }

      return isValidPhoneNumber(formattedNumber);
    } catch (_error) {
      // error can contain useful information about what went wrong
      // but for the sake of this function, we don't care what went wrong
      // merely that it is an invalid phone number
      return false;
    }
  }
}

// Form validation determines validity based on E.164 format and automatically determines
// country code, defaulting to US.
export function phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
  const phoneNumber = control.value;

  if (!phoneNumber) {
    return null;
  }

  try {
    const isValidNumber = PhoneNumberHelper.isValid(phoneNumber);

    if (!isValidNumber) {
      return { invalidPhoneNumber: true };
    }

    return null;
  } catch (_error) {
    return { invalidPhoneNumber: true };
  }
}
